import { SelectionCellContainer } from '../selectionCell';
import { SelectionHeaderContainer } from '../selectionHeader';

export const selectionColumn = {
  id: 'selection',
  Cell: SelectionCellContainer,
  Header: SelectionHeaderContainer,
};
